/**
 * Created by Christof Sander on 22.06.2016.
 *
 * this module collects all constants needed
 *
 * INFO: never use zero as value so isEmpty function can be used within the code
 */

module.exports = Object.freeze({
	ERROR: {
		LEVEL: {
			LOG:        1,
			WARNING:    2,
			ERROR:      3,
			CRITICAL:  	4
		},
		HANDLING_TYPE: {
			DEFAULT:                        1,
			NOT_HANDLED_LOCAL:              2,
			DURING_GLOBAL_ERROR_HANDLING:   3,
			DURING_LOCAL_ERROR_HANDLING:    4
		}
	},
	COMPONENT: {
		ACTION: {
			TYPE: {
				OPEN:               1,
				LOAD:               2,
				TAB:                3,
				INCLUDE:            4,
				LOAD_RESOURCE:      5,
				SUBMIT_RESOURCE:    6,
				ACCORDION:			7
			},
			TARGET: {
				ELEMENT: {
					SELECTOR:           1,
					SUB_SELECTOR:       2,
					SELF:               3,
					PARENT_COMPONENT:   4,
					JQUERY: 			5,
					ACTION_SOURCE_KEY:	6,
				},
				POSITION: {
					HTML:       1,
					REPLACE:    2,
					BEFORE:     3,
					AFTER:      4,
					APPEND:     5,
					PREPEND:    6,
					ATTACH:     7,
					MODAL:      8
				},
				MODE: {
					INVALID:    1,
					JQUERY:     2,
					COMPONENT:  3
				}
			}
		},
		BUILD_GRANTED: {
			TYPE: {
				// if a component grants or denies to be built it may decide if the decision is based on conditions indicating that not only the build but also the html may be cached.
				NO: 1, // no build granted - without cache
				NO_CACHED: 2, // no build granted - decision cacheable
				YES: 3, // build granted - without cache
				YES_CACHED: 4, // build granted - decision cacheable
			}
		},
	},

	TRLS: {
		KEYS: {
			MODEL_FIELDS: [
				'label',
				'description',
				'info',
			]
		}
	},

	TEMPLATE: {
		ATOM: {
			STRING:     1,
			HTML:       2,
			JSON:       3,
			INT:        4,
			BOOLEAN:    5,
			LIST:       6,
			TEMPLATE:   7,
			URL:        8,
			FORM_FIELD: 9
		}
	},

	// which route subTypes (cms_routes.subType) should be rendered
	RENDER_ROUTE_SUB_TYPES: {
		page: true,				// normal routeTree node
		newsletter: true,		// newsletter route
		mail: true,				// system mail route
		mblx_product: true,		// mblx product route
		ninja: true,			// all ninja_ types (e.g., ninja_news, ninja_events, ...)
	},

	// which route subTypes (cms_routes.subType) should be included within the sitemaps.
	// NOTE: the boolean value will be ignored.
	// NOTE: ninja routes will be handled according to their ninjaModule appConfig
	SITEMAP_ROUTE_SUB_TYPES: {
		page: true,				// normal routeTree node
	},

	// which route subTypes (cms_routes.subType) should be rendered
	// NOTE: ninja routes will be handled according to their ninjaModule appConfig
	PREWARM_ROUTE_SUB_TYPES: {
		language: true,			// language node
		page: true,				// normal routeTree node
	},
});
